import React from "react";

import "./MainHeader.css";

const MainHeader = (props) => {
  return (
    <header id="MainHeader" className="main-header">
      {props.children}
    </header>
  );
};

export default MainHeader;
